import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Home = () => {
  const features = [
    {
      icon: 'fas fa-utensils',
      title: 'უმაღლესი ხარისხი',
      description: 'ჩვენ ვიყენებთ მხოლოდ უმაღლესი ხარისხის ინგრედიენტებს'
    },
    {
      icon: 'fas fa-users',
      title: 'მეგობრული მომსახურება',
      description: 'ჩვენი პერსონალი ყოველთვის მზადაა დაგეხმაროთ'
    },
    {
      icon: 'fas fa-star',
      title: 'უნიკალური გემოები',
      description: 'ქართული და ევროპული კერძების უნიკალური კომბინაცია'
    }
  ];

  const specialOffers = [
    {
      title: 'შაბათის ბუფეტი',
      price: '₾45',
      description: 'ყველა შაბათს 12:00-16:00',
      image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400'
    },
    {
      title: 'საქორწინო მენიუ',
      price: '₾35/ადამიანი',
      description: 'სპეციალური ფასები ქორწილისთვის',
      image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=400'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section text-white text-center py-5">
        <div className="hero-overlay">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <h1 className="display-4 fw-bold mb-4">
                  მოგესალმებათ რესტორანი ატმოსფერო
                </h1>
                <p className="lead mb-4">
                  განიცადეთ ქართული სამზარეულოს უნიკალური გემოები 
                  მშვენიერი ატმოსფეროთი და მეგობრული მომსახურებით
                </p>
                <div className="d-flex gap-3 justify-content-center flex-wrap">
                  <Button 
                    as={Link} 
                    to="/menu" 
                    variant="warning" 
                    size="lg"
                    className="fw-bold"
                  >
                    <i className="fas fa-utensils me-2"></i>
                    მენიუ
                  </Button>
                  <Button 
                    as={Link} 
                    to="/reservation" 
                    variant="outline-light" 
                    size="lg"
                    className="fw-bold"
                  >
                    <i className="fas fa-calendar-check me-2"></i>
                    დაჯავშნა
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-5 fw-bold text-dark">რატომ ჩვენ?</h2>
              <p className="lead text-muted">ჩვენი უპირატესობები</p>
            </Col>
          </Row>
          
          <Row>
            {features.map((feature, index) => (
              <Col md={4} key={index} className="mb-4">
                <div className="text-center p-4">
                  <div className="feature-icon mb-3">
                    <i className={`${feature.icon} fa-3x text-warning`}></i>
                  </div>
                  <h4 className="fw-bold mb-3">{feature.title}</h4>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Special Offers Section */}
      <section className="py-5">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-5 fw-bold text-dark">სპეციალური შეთავაზებები</h2>
              <p className="lead text-muted">დღევანდელი ფასები</p>
            </Col>
          </Row>
          
          <Row>
            {specialOffers.map((offer, index) => (
              <Col lg={6} key={index} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <div className="position-relative">
                    <Card.Img 
                      variant="top" 
                      src={offer.image} 
                      alt={offer.title}
                      style={{ height: '250px', objectFit: 'cover' }}
                    />
                    <div className="position-absolute top-0 end-0 m-3">
                      <span className="badge bg-warning text-dark fs-6 px-3 py-2">
                        {offer.price}
                      </span>
                    </div>
                  </div>
                  <Card.Body className="text-center">
                    <Card.Title className="fw-bold fs-4">{offer.title}</Card.Title>
                    <Card.Text className="text-muted">{offer.description}</Card.Text>
                    <Button variant="outline-warning" className="fw-bold">
                      დეტალები
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section className="py-5 bg-dark text-white text-center">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2 className="display-5 fw-bold mb-4">
                მოგესალმებათ რესტორანი ატმოსფერო
              </h2>
              <p className="lead mb-4">
                დაჯავშნე ონლაინ მარტივად
              </p>
              <Button 
                as={Link} 
                to="/reservation" 
                variant="warning" 
                size="lg"
                className="fw-bold"
              >
                <i className="fas fa-calendar-check me-2"></i>
                დაჯავშნა
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
